import { render, staticRenderFns } from "./AdminData.vue?vue&type=template&id=2bc02310"
import script from "./AdminData.vue?vue&type=script&lang=js"
export * from "./AdminData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports